import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  Optional,
  Self,
  ViewChild,
} from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';

import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Loading } from '@fleet-beat/core';
import { AnexConfig } from '@fleet-beat/editor';
import { SimpleField } from '../../abstracts';
import moment, { Moment } from 'moment';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'fb-date-field',
  templateUrl: './date-field.component.html',
  styleUrls: ['./date-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFieldComponent extends SimpleField<[string, string]> implements OnInit {
  @Input() prefix: AnexConfig;
  @Input() noLabel: boolean;
  @Input() minLength: number;
  @Input() maxLength: number;
  @Input() withArrows: number;
  @Input() withReset: number;
  @Input() maxDate: Date | Moment | string;
  @Input() min: number;
  @Input() max: number;
  @Input() timezone: string;
  @Input() loading: Loading = new Loading();

  @Input() formControl: FormControl;

  @ViewChild('picker') datePicker: MatDateRangePicker<unknown>;

  selectedDate: Date;
  readonly defaultAppearance: MatFormFieldAppearance = 'outline';

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    public override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }

  ngOnInit(): void {
    if (this.ngControl.control.value) {
      this.selectedDate = new Date(this.ngControl.control.value);
    }
    this.ngControl.control.valueChanges.pipe(untilComponentDestroyed(this)).subscribe((data: Moment | null) => {
      if (data) {
        this.selectedDate = new Date(data.toString());
      } else {
        this.selectedDate = null;
      }
    });
    if (this.maxDate && moment.isMoment(this.maxDate)) {
      this.maxDate = new Date(this.maxDate.year(), this.maxDate.month(), this.maxDate.date(), 23, 59, 59, 999);
    }
  }

  onClear(): void {
    this.formControl.reset();
  }

  onSwitch(value: 'left' | 'right'): void {
    if (
      this.maxDate &&
      moment(this.selectedDate).format('YYYY-MM-DD') === moment(this.maxDate).format('YYYY-MM-DD') &&
      value === 'right'
    ) {
      return;
    }
    switch (value) {
      case 'left':
        this.selectedDate.setDate(this.selectedDate.getDate() - 1);
        break;
      case 'right':
        this.selectedDate.setDate(this.selectedDate.getDate() + 1);
        break;
    }
    this.ngControl.control.setValue(moment(this.selectedDate).startOf('day').toISOString());
  }
}
